import BaseApi from "./baseAPI";

class AnnouncementAPI extends BaseApi {
  get entity () {
    return {
      route: `/announcements`,
      name: 'إعلان'
    }
  }

  getAllByCourse(course_id){
    return new Promise((resolve, reject) => {
      return this.request.get(`${this.entity.route}`, {params: {course_id: course_id}})
        .then(response => resolve(this.responseWrapper(response)))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

  delete(id, course_id){
    return new Promise((resolve, reject) => {
      return this.request.post(`${this.entity.route}/${id}`, {_method: 'delete', course_id: course_id})
        .then(response => resolve(this.responseWrapper(response, this.entity.name, 'delete')))
        .catch(error => reject(this.errorWrapper(error)))
    })
  }

}

export default new AnnouncementAPI()
